import { isTextNode } from 'anodum';

const removeTextSiblings = ({ previousSibling, nextSibling }) => {
  const siblingsArr = [previousSibling, nextSibling];
  siblingsArr.forEach((node) => isTextNode(node) && node.remove());
};

export default removeTextSiblings;
